import React, { Component } from "react";
import settings from "../../settings";
import Auth from "../../models/Auth";
import FetchResponses from "../../models/FetchResponses";
import { Modal } from 'antd'
import Logger from "../../models/Logger";
// redux
import { connect } from "react-redux";
import { SetMenuManager } from "../Actions/Menu_Actions";
import AdminLayout from "../Layouts/AdminLayout";
import { Collapse } from "antd";

const Panel = Collapse.Panel;

class SettingsManager extends Component {
  confirm = Modal.confirm
  constructor(props) {
    super(props);
    Logger.setLogger(this.constructor.name);

    this.state = {
      loading: false,
      radioSelection: {},
      radioSelectionBackup: {},
      variables: {
        SINGLE_VARIABLE: []
      },
      values: {},
    };
  }

  getAllVariables = () => {
    this.setState({ loading: true })
    let url = settings.backend.variables;
    fetch(url, {
      method: "GET",
      headers: settings.headers_auth(Auth.getSessionToken()),
    })
      .then(FetchResponses.processResponse)
      .then((response) => {
        this.setState({ loading: false })
        if (response) {
          const radioSelection = {};
          Object.keys(response).forEach((sectionKey) => {
            const activeVar = response[sectionKey].find((v) => v.is_active && v.type === "radio");
            if (activeVar) {
              radioSelection[sectionKey] = activeVar.id;
            }
          });
          console.log('radioSelection: ', radioSelection);
          this.setState({ variables: response, radioSelection, radioSelectionBackup: { ...radioSelection },});
      
        }
      })
      .catch(this.failureDataResponse);
  };

  failureDataResponse = (error) => {
    this.setState({
      open: true,
      error_message: error.msg || 'Ups, ha ocurrido un error, por favor comunicarse con el administrador de la página',
      showAddPageSection: false,
      showCreateOptionMenu: false,
    });
  };

  componentDidMount = async () => {
    this.getAllVariables();
  };

  handleInputChange = (event, variableId) => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      values: {
        ...prevState.values,
        [variableId]: {
          ...prevState.values[variableId],
          [name]: value
        }
      }
    }));
  };
  guardarRadio = () => {
    const { radioSelection } = this.state;
    Object.entries(radioSelection).forEach(([sectionKey, value]) => {
      this.activateVariable(value, false, sectionKey)
    });
  
  };

  handleRadioChange = (sectionKey, variable) => {
    this.setState((prevState) => {  
      return {
        radioSelection: {
          ...prevState.radioSelection,
          [sectionKey]: variable.id,
        }
      };
    });
  };
  
  cancelarCambio = (sectionKey) => {
    this.setState((prevState) => ({
      radioSelection: {
        ...prevState.radioSelection,
        [sectionKey]: prevState.radioSelectionBackup[sectionKey],
      },
    }));
  };
  activateVariable = (variableId, active, funcionalidad) => {
    let _this = this
    this.confirm({
      content: `¿Está seguro de que desea cambiar el estado de la funcionalidad de ${funcionalidad}? Este cambio se aplicará de inmediato.`,
      okText: 'Sí, cambiar estado',
      cancelText: 'Cancelar',
      confirmLoading: this.state.loading,
      onOk() {
        _this.setState({ loading: true })
        let url = settings.backend.variables + variableId + "/";

        return fetch(url, {
          method: "PATCH",
          headers: {
            ...settings.headers_auth(Auth.getSessionToken()),
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ is_active: !active })
        })
          .then(FetchResponses.processResponse)
          .then(() => {
            _this.getAllVariables()
            _this.setState({ loading: false })
          })
          .catch(_this.failureDataResponse);
      },
      onCancel() { },
    })
  }

  render() {
    return (
      <AdminLayout>
      <div>
        {Object.keys(this.state.variables).map((sectionKey) => (
          <div key={sectionKey}>
            {sectionKey !== "SINGLE_VARIABLE" ? (
              <Collapse bordered={false} defaultActiveKey={[""]} accordion onChange={this.handleChangeSection}>
                <Panel header={sectionKey} key="1" className="panel" >
                  {this.state.variables[sectionKey].map((variable) => (
                    <div className="col-12 col-md-auto d-flex justify-content-between align-items-center gap-3 mb-4 settings-toggle-buttons"  key={variable.id}>
                      {variable.type === "radio" ? (
                        <div className="d-flex align-items-center gap-2">
                          <input
                            type="radio"
                            name={sectionKey}
                            style = {{
                              accentColor: "#a00",
                              width: "18px",
                              height: "18px",
                            }}
                            value={variable.name}
                            checked={
                              this.state.radioSelection &&
                              this.state.radioSelection[sectionKey] === variable.id
                            }
                            onChange={() => this.handleRadioChange(sectionKey, variable)}
                          />
                          <span>{variable.label}</span>
                        </div>
                      ) : (
                        <>
                          <label htmlFor={`switch-${variable.id}`} className="fw-bold mb-0">
                            {variable.label}
                          </label>
                          <div className="form-check form-switch m-0">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id={`switch-${variable.id}`}
                              checked={variable.is_active}
                              style={{
                                transform: "scale(1.3)",
                                cursor: "pointer",
                                backgroundColor: variable.is_active ? "#a00" : "",
                                borderColor: variable.is_active ? "#a00" : "",
                              }}
                              onChange={() =>
                                this.activateVariable(variable.id, variable.is_active, variable.label)
                              }
                            />
                          </div>
                        </>
                      )}

                      
                    </div>
                  ))}

                  {this.state.radioSelection[sectionKey] !== undefined && (
                      <div className="d-flex gap-2 mt-2">
                        <button
                          className="btn red-outlined-btn col-6"
                          onClick={() => this.cancelarCambio(sectionKey)}
                        >
                          Cancelar
                        </button>
                        <button
                          className="btn btn-primary col-6"  style={{
                            backgroundColor: "#B21213",
                            borderColor: "#B21213",
                            borderRadius: "8px"
                          }}
                          onClick={() => this.guardarRadio(sectionKey)}
                        >
                          Guardar
                        </button>
                      </div>
                    )}


                </Panel>
              </Collapse>
            ) : (
              this.state.variables[sectionKey].map((variable) => (
                <div className="panel row g-2 align-items-center" key={variable.id}>
                  <div className="col-12 col-md-auto d-flex justify-content-between align-items-center gap-3">
                    {variable.type === "radio" && (
                      <label>
                        <input type="radio" name={variable.name} value={variable.value} />
                        {variable.label}
                      </label>
                    )}
                    <label htmlFor={`switch-${variable.id}`} className="fw-bold mb-0">
                      {variable.label}
                    </label>
                    <div className="form-check form-switch m-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id={`switch-${variable.id}`}
                        checked={variable.is_active}
                        style={{
                          transform: "scale(1.3)",
                          cursor: "pointer",
                          backgroundColor: variable.is_active ? "#a00" : "",
                          borderColor: variable.is_active ? "#a00" : "",
                        }}
                        onChange={() =>
                          this.activateVariable(variable.id, variable.is_active, variable.label)
                        }
                      />
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        ))}
      </div>
    </AdminLayout>
    


    );
  }
}

const mapStateToProps = (state) => ({
  menu: state.menu.menu,
});

export default connect(mapStateToProps, { SetMenuManager })(SettingsManager);
